export const TASK_CATEGORIES_OPTIONS = {
  HS: [
    { key: 'Academics', human: 'Academics' },
    { key: 'Attendance', human: 'Attendance' },
    { key: 'Attendance Outreach', human: 'Attendance Outreach' },
    { key: 'Credits', human: 'Credits' },
    { key: 'General', human: 'General' },
    { key: 'Graduation', human: 'Graduation' },
    { key: 'Point People', human: 'Point People' },
    { key: 'Postsecondary', human: 'Postsecondary' },
    { key: 'Regents', human: 'Regents' },
    { key: 'Remote Learning', human: 'Remote Learning' },
    { key: 'Screeners / Assessments', human: 'Screeners / Assessments' },
    { key: 'Supports', human: 'Supports' },
  ],
  MS: [
    { key: 'Academics', human: 'Academics' },
    { key: 'Attendance', human: 'Attendance' },
    { key: 'Attendance Outreach', human: 'Attendance Outreach' },
    { key: 'General', human: 'General' },
    { key: 'Point People', human: 'Point People' },
    { key: 'Remote Learning', human: 'Remote Learning' },
    { key: 'Screeners / Assessments', human: 'Screeners / Assessments' },
    { key: 'Supports', human: 'Supports' },
  ],
  ES: [
    { key: 'Academics', human: 'Academics' },
    { key: 'Attendance', human: 'Attendance' },
    { key: 'Attendance Outreach', human: 'Attendance Outreach' },
    { key: 'General', human: 'General' },
    { key: 'Point People', human: 'Point People' },
    { key: 'Remote Learning', human: 'Remote Learning' },
    { key: 'Screeners / Assessments', human: 'Screeners / Assessments' },
    { key: 'Supports', human: 'Supports' },
  ],
  SHELTER: [
    { key: 'General', human: 'General' },
    { key: 'Success Mentoring', human: 'Success Mentoring' },
  ],
};
